const hexColorRegex = /^#(([a-f0-9]){3}){1,2}$/i;
const hexaColorRegex = /^#([a-f0-9]{8}|[a-f0-9]{4})\b$/i;

// COLOR ASSERTIONS

export const isHexColor = (value: string): boolean => hexColorRegex.test(value);

export const isHexaColor = (value: string): boolean =>
  hexaColorRegex.test(value);

export const isRgbColor = (value: string): boolean => value.includes('rgb');

// COLOR CONVERSIONS

export const hexToRGBA = (hex: string, opacity: number) => {
  if (hex.includes('rgba')) {
    const tokens = hex.split(',');
    tokens[3] = `${opacity})`;
    return tokens.join(',');
  }

  const rawHexColorId = hex.replace('#', '');
  const r = parseInt(rawHexColorId.substring(0, 2), 16);
  const g = parseInt(rawHexColorId.substring(2, 4), 16);
  const b = parseInt(rawHexColorId.substring(4, 6), 16);

  return `rgba(${r},${g},${b},${opacity})`;
};

// COLOR EXTRACTIONS

export const getAlphaFromRgba = function (rgba: string) {
  const rgbaRegex = /^rgba\(((\d+),\s*){3}(0?\.\d+)\)$/;
  if (rgbaRegex.test(rgba)) {
    const tokens = rgba.split(',');
    const alpha = tokens[3];
    return alpha.split(')')[0];
  }

  return 1;
};
